export default __webpack_public_path__ + "static/media/logoNavbar.380ce0a9.png";